import { PopoverPlacement } from "@idui/react-popover";
import { WarningAmber as WarningAmberIcon } from "@mui/icons-material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { TInfoItem, translateInfoItem } from "@ryde/shared";

import { IRenderColumnTemplate } from "../_core";
import { FramerTooltip } from "../../../common";
import {
  WarningsDisplayRootEmptyStyled,
  WarningsDisplayRootStyled,
  WarningsTooltipStackStyled,
} from "./warnings-display.styled";
import { normalizeWarningsValue } from "./warnings-display.utils";

export const WarningsDisplayCellTemplate: FC<IRenderColumnTemplate> = ({
  value: rawValue,
}) => {
  const { t } = useTranslation();

  const items = useMemo(() => normalizeWarningsValue(rawValue), [rawValue]);

  const tooltipContent = useMemo(
    () => (
      <WarningsTooltipStackStyled>
        {items.map((line, index) => (
          <span key={index}>{translateInfoItem(line as TInfoItem, t)}</span>
        ))}
      </WarningsTooltipStackStyled>
    ),
    [items, t],
  );

  if (!items.length) {
    return <WarningsDisplayRootEmptyStyled />;
  }

  return (
    <WarningsDisplayRootStyled>
      <FramerTooltip
        content={tooltipContent}
        placement={PopoverPlacement.bottom}
      >
        <span className="warnings-display-cell">
          <WarningAmberIcon sx={{ fontSize: 18 }} />
          <span className="warnings-display-count">{items.length}</span>
        </span>
      </FramerTooltip>
    </WarningsDisplayRootStyled>
  );
};
